const styles = {
  card: {
    maxWidth: '200px',
    display: 'inline-block',
    marginLeft: '15px',
    marginBottom: '15px',
  },
  meta: {},
  image: {
    width: '100%',
    height: '225px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/styles/BookCard.js